import React from "react";
import {Button, Form, Input, Modal, Upload} from "antd";
import {FormModalProps} from "../../utils/useFormModal";
import Select from "../../components/Select";

function ModifyModal(props: FormModalProps) {

    const {form, ...otherProps} = props

    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'classificationId'} label={'Classification'}
                           rules={[{required: true, message: 'Please select classification'}]}>
                    <Select url={'/documents/classification'} textField={'name'} valueField={'id'}
                            getData={data => data.data}/>
                </Form.Item>
                <Form.Item name={'title'} label={'Title'} rules={[{required: true, message: 'Please input name'}]}>
                    <Input/>
                </Form.Item>
                <Form.Item name={'path'} label={'File'} rules={[{required: true, message: 'Please upload file'}]}>
                    <Upload beforeUpload={() => false}>
                        <Button type={'primary'}>Upload</Button>
                    </Upload>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal;
